import { render, staticRenderFns } from "./levy.vue?vue&type=template&id=73528894&scoped=true"
import script from "./levy.vue?vue&type=script&lang=ts"
export * from "./levy.vue?vue&type=script&lang=ts"
import style0 from "./levy.vue?vue&type=style&index=0&id=73528894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73528894",
  null
  
)

export default component.exports